import React from 'react';
import FileExplorerContent from '../content/FileExplorerContent';
import ChromeBrowserContent from '../content/ChromeBrowserContent';
import SecurityCenterContent from '../content/SecurityCenterContent';
import ControlPanelContent from '../content/ControlPanelContent';
import RegistryEditorContent from '../content/RegistryEditorContent';
import ServicesContent from '../content/ServicesContent';
import NotepadContent from '../content/NotepadContent';
import CalculatorContent from '../content/CalculatorContent';
import TaskManagerContent from '../content/TaskManagerContent';
import OutlookContent from '../content/OutlookContent';
import EnhancedRegistryEditorContent from '../content/EnhancedRegistryEditorContent';
import EnhancedNotepadContent from '../content/EnhancedNotepadContent';
import CommandPromptContent from '../content/CommandPromptContent';

const WindowContent = React.memo(({ windowId, appId, initialPath, scenario, onComplete, processes, onEndTask, systemSpecs, fileSystem, setFileSystem, addFileToDownloads, addNotification, onExecuteFile, onOpenFolder, onQuarantine, onDeleteFile, onExecuteCommand, activeStep, networkFlows }) => {
  switch (appId) {
    case 'explorer':
      return (
        <FileExplorerContent
          scenario={scenario}
          onComplete={onComplete}
          initialPath={initialPath}
          fileSystem={fileSystem}
          setFileSystem={setFileSystem}
          onExecuteFile={onExecuteFile}
          onOpenFolder={onOpenFolder}
          onQuarantine={onQuarantine}
          onDeleteFile={onDeleteFile}
        />
      );
    case 'chrome':
      return <ChromeBrowserContent scenario={scenario} onComplete={onComplete} />;
    case 'notepad':
      // Use enhanced notepad for script analysis scenarios
      if (scenario?.fileContent || scenario?.scriptAnalysis) {
        return <EnhancedNotepadContent scenario={scenario} onComplete={onComplete} fileContent={scenario.fileContent} />;
      }
      return <NotepadContent scenario={scenario} onComplete={onComplete} />;
    case 'calculator':
      return <CalculatorContent scenario={scenario} onComplete={onComplete} />;
    case 'outlook':
      return <OutlookContent scenario={scenario} onComplete={onComplete} addFileToDownloads={addFileToDownloads} addNotification={addNotification} />;
    case 'securitycenter':
      return <SecurityCenterContent scenario={scenario} onComplete={onComplete} />;
    case 'controlpanel':
      return <ControlPanelContent scenario={scenario} onComplete={onComplete} />;
    case 'regedit':
      // Use enhanced registry editor for malware scenarios
      if (scenario?.maliciousEntries || scenario?.registryAnalysis) {
        return <EnhancedRegistryEditorContent scenario={scenario} onComplete={onComplete} />;
      }
      return <RegistryEditorContent scenario={scenario} onComplete={onComplete} />;
    case 'taskmgr':
      return <TaskManagerContent scenario={scenario} onComplete={onComplete} processes={processes} onEndTask={onEndTask} systemSpecs={systemSpecs} networkFlows={scenario?.networkFlows || []} />;
    case 'services':
      return <ServicesContent scenario={scenario} onComplete={onComplete} />;
    case 'cmd':
      return (
        <CommandPromptContent
          scenario={scenario}
          activeStep={activeStep}
          onExecuteCommand={onExecuteCommand}
        />
      );
    default:
      return (
        <div className="p-4 h-full bg-white">
          <p>Application content for {appId}</p>
        </div>
      );
  }
}, (prevProps, nextProps) => {
  // Only re-render if these specific props change
  return prevProps.windowId === nextProps.windowId &&
         prevProps.appId === nextProps.appId &&
         prevProps.initialPath === nextProps.initialPath &&
         prevProps.scenario === nextProps.scenario &&
         prevProps.onComplete === nextProps.onComplete &&
         prevProps.processes === nextProps.processes &&
         prevProps.onEndTask === nextProps.onEndTask &&
         prevProps.systemSpecs === nextProps.systemSpecs &&
         prevProps.fileSystem === nextProps.fileSystem &&
         prevProps.setFileSystem === nextProps.setFileSystem &&
         prevProps.addFileToDownloads === nextProps.addFileToDownloads &&
         prevProps.addNotification === nextProps.addNotification &&
         prevProps.onExecuteFile === nextProps.onExecuteFile &&
         prevProps.onOpenFolder === nextProps.onOpenFolder &&
         prevProps.onQuarantine === nextProps.onQuarantine &&
         prevProps.onDeleteFile === nextProps.onDeleteFile &&
         prevProps.onExecuteCommand === nextProps.onExecuteCommand &&
         prevProps.activeStep === nextProps.activeStep &&
         prevProps.networkFlows === nextProps.networkFlows;
});

export default WindowContent;